import React, { useState } from 'react';
import { Button, Label, Modal, ModalBody, ModalFooter, ModalHeader, Form, FormGroup, Table, Input } from 'reactstrap';
import { MrbItemType } from 'app/shared/model/enumerations/mrb-item-type.model';
import { IMrbItem } from 'app/shared/model/mrbItem.model';
import { VoteOutcome } from 'app/shared/model/enumerations/vote-outcome.model';
import { FieldMessage } from 'app/common/components/ui/button/FieldMessage';

const INITIATE_CAPA = VoteOutcome.INCIDENT_INITIATE_CAPA;
const CLOSE_NO_CAPA = VoteOutcome.INCIDENT_CLOSE_NO_CAPA;
const REQUEST_NOTE_MSG = 'Enter a note for the vote';

interface IMrbItemFollowup extends IMrbItem {
  itemType: MrbItemType.FOLLOWUP;
}

export interface IVotingModalProps {
  followup: IMrbItemFollowup;
  showModal: boolean;
  toggleModal: Function;
  voteHandler: Function;
  rowClassName: string;
}

export const FollowupVotingModal = (props: IVotingModalProps) => {
  const { followup, showModal, toggleModal, voteHandler, rowClassName } = props;

  const [note, setNote] = useState('');
  const [requestNote, setRequestNote] = useState(false);
  const [outcome, setOutcome] = useState(INITIATE_CAPA);

  const resetModal = () => {
    setNote('');
    setOutcome(INITIATE_CAPA);
  };

  const noteChangeHandler = event => {
    setNote(event.target.value);
    if (note) {
      setRequestNote(false);
    }
  };

  const formSubmitHandler = event => {
    event.preventDefault();
    if (note && outcome) {
      const vote = {
        note,
        outcome,
        followup: {
          id: followup.id,
        },
        createdDate: null,
        updatedDate: null,
      };
      voteHandler(vote);
      toggleModal();
      resetModal();
    }
    if (!note) {
      setRequestNote(true);
    }
  };

  const cancelHandler = () => {
    toggleModal();
    resetModal();
  };

  return (
    <Modal isOpen={showModal} toggle={toggleModal} className={'className'}>
      <Form onSubmit={formSubmitHandler}>
        <ModalHeader toggle={toggleModal}>Followup Vote</ModalHeader>
        <ModalBody>
          <dl className="jh-entity-details">
            <dt>
              <span id="id">ID</span>
            </dt>
            <dd>{followup.id || null}</dd>
            <dt>
              <span id="title">Incident Title</span>
            </dt>
            <dd className="text-truncate">{followup.incidentTitle || null}</dd>
          </dl>
          <FormGroup>
            <Label id="noteLabel" for="vote-note">
              Note
            </Label>
            <Input id="vote-note" type="text" name="note" value={note} placeholder="Enter a note" onChange={noteChangeHandler} />
            <FieldMessage condition={requestNote} message={REQUEST_NOTE_MSG} />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button type="submit" color="success" onClick={() => setOutcome(VoteOutcome.FOLLOWUP_EFFECTIVE_CLOSE)}>
            CAPA Effective
          </Button>
          <Button type="submit" color="danger" onClick={() => setOutcome(VoteOutcome.FOLLOWUP_INEFFECTIVE_NEW_INCIDENT)}>
            Ineffective - New Incident
          </Button>
          <Button type="button" className="mr-1" color="secondary" onClick={cancelHandler} tabIndex="1">
            Cancel
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};
